// Comprehensive color palette for CAI Modena Gite application
const colors = {
  // Brand colors
  primary: {
    50: '#EFF6FF',
    100: '#DBEAFE',
    200: '#BFDBFE',
    300: '#93C5FD',
    400: '#60A5FA',
    500: '#3B82F6',
    600: '#2563EB',
    700: '#1D4ED8',
    800: '#1E40AF',
    900: '#1E3A8A',
    DEFAULT: '#1D4ED8', // Main brand blue
    dark: '#1E3A8A',    // Darker shade for hover
    light: '#93C5FD',   // Lighter shade for disabled states
  },

  // Semantic colors
  success: {
    50: '#F0FDF4',
    100: '#DCFCE7',
    200: '#BBF7D0',
    300: '#86EFAC',
    400: '#4ADE80',
    500: '#22C55E',
    600: '#16A34A',
    DEFAULT: '#16A34A',
  },

  warning: {
    50: '#FFFBEB',
    100: '#FEF3C7',
    200: '#FDE68A',
    300: '#FCD34D',
    400: '#FBBF24',
    500: '#F59E0B',
    600: '#D97706',
    DEFAULT: '#F59E0B',
  },

  danger: {
    50: '#FEF2F2',
    100: '#FEE2E2',
    200: '#FECACA',
    300: '#FCA5A5',
    400: '#F87171',
    500: '#EF4444',
    600: '#DC2626',
    DEFAULT: '#DC2626',
  },

  info: {
    50: '#EFF6FF',
    100: '#DBEAFE',
    200: '#BFDBFE',
    300: '#93C5FD',
    400: '#60A5FA',
    500: '#3B82F6',
    DEFAULT: '#3B82F6',
  },

  // Tag colors (hiking difficulty levels)
  // CAI scale: T < E < EE < EEA (progressive green → yellow → red → dark red)
  // EAI: winter variant (ice blue)
  // Alpine scale: A < F < PD < AD (purple/indigo tones)
  // Text-based tags mirror the CAI scale colors
  tags: {
    T: {
      bg: 'bg-green-100',
      text: 'text-green-800',
    },
    E: {
      bg: 'bg-amber-100',
      text: 'text-amber-800',
    },
    EE: {
      bg: 'bg-red-100',
      text: 'text-red-800',
    },
    EEA: {
      bg: 'bg-red-200',
      text: 'text-red-900',
    },
    EAI: {
      bg: 'bg-cyan-100',
      text: 'text-cyan-800',
    },
    A: {
      bg: 'bg-purple-100',
      text: 'text-purple-800',
    },
    F: {
      bg: 'bg-slate-100',
      text: 'text-slate-700',
    },
    PD: {
      bg: 'bg-violet-100',
      text: 'text-violet-800',
    },
    AD: {
      bg: 'bg-indigo-100',
      text: 'text-indigo-900',
    },
    'Facile': {
      bg: 'bg-green-100',
      text: 'text-green-800',
    },
    'Moderatamente difficile': {
      bg: 'bg-amber-100',
      text: 'text-amber-800',
    },
    'Difficile': {
      bg: 'bg-orange-100',
      text: 'text-orange-800',
    },
    'Molto difficile': {
      bg: 'bg-red-100',
      text: 'text-red-800',
    },
    'Estremamente difficile': {
      bg: 'bg-red-200',
      text: 'text-red-900',
    },
    default: {
      bg: 'bg-gray-100',
      text: 'text-gray-800',
    },
  },

  // Text colors
  text: {
    primary: 'text-gray-900',
    secondary: 'text-gray-600',
    tertiary: 'text-gray-500',
    white: 'text-white',
    link: 'text-blue-600',
    success: 'text-green-600',
    warning: 'text-yellow-600',
    danger: 'text-red-600',
  },

  // Background colors
  background: {
    primary: 'bg-white',
    secondary: 'bg-gray-50',
    tertiary: 'bg-gray-100',
    dark: 'bg-gray-900',
    header: '#282c34',
    reactBlue: '#61dafb',
  },

  // Button states
  button: {
    primary: {
      default: 'bg-blue-600 text-white',
      hover: 'hover:bg-blue-700',
      active: 'active:bg-blue-800',
      disabled: 'disabled:bg-blue-300',
    },
    secondary: {
      default: 'bg-gray-200 text-gray-800',
      hover: 'hover:bg-gray-300',
      active: 'active:bg-gray-400',
      disabled: 'disabled:bg-gray-100',
    },
    danger: {
      default: 'bg-red-600 text-white',
      hover: 'hover:bg-red-700',
      active: 'active:bg-red-800',
      disabled: 'disabled:bg-red-300',
    },
  },

  // Spinner colors
  spinner: {
    white: 'border-white border-t-transparent',
    blue: 'border-blue-600 border-t-transparent',
    gray: 'border-gray-600 border-t-transparent',
    primary: 'border-blue-600 border-t-transparent',
  },
};

export default colors;